export default function (initialDataInteractor) {
  return initialDataInteractor.secret_key;
}